export enum ContactDetailTabs {
    Overview = 'overview',
    Permissions = 'permissions',
    Documents = 'documents',
}
